import styled, { css } from 'styled-components';
import { TLocalDisplayMode } from '../../../types/twilio';

const windowStyles = css`
  top: 30px;
  right: 30px;
  width: 270px;
  height: 205px;
  border-radius: 30px;
  z-index: 99998;
  border: 1px solid #ffffff;
  background: black;

  .participant-name {
    position: absolute;
    left: 7.86%;
    bottom: 5px;
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 25px;
    z-index: 99998;
    color: #ffffff;
  }

  video {
    height: 100%;
  }
`;

const windowStylesRemote = css`
  top: 30px;
  right: 30px;
  width: 205px;
  height: 270px;
  border-radius: 30px;
  z-index: 99998;
  border: 1px solid #ffffff;

  .participant-name {
    position: absolute;
    left: 7.86%;
    bottom: 5px;
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 25px;
    z-index: 99998;
    color: #ffffff;
  }
  video {
    height: 100%;
  }
`;

const fullStylesRemote = css`
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  border-radius: 0;
  z-index: 99997;

  .participant-name {
    position: absolute;
    height: 40px;
    left: 3.47%;
    bottom: 25px;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 40px;
    z-index: 99998;
    color: #ffffff;
  }
  video {
    width: auto;
    height: 100%;
  }
`;

const fullStyles = css`
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  border-radius: 0;
  z-index: 99997;

  .participant-name {
    position: absolute;
    height: 40px;
    left: 3.47%;
    bottom: 25px;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 40px;
    z-index: 99998;
    color: #ffffff;
  }
  video {
    width: 100%;
  }
`;

/**
 * https://stackoverflow.com/questions/36949747/make-video-fit-100-with-any-screen-resolution
 */
export const ParticipantSC = styled.div<{
  type: 'local' | 'remote';
  displayMode: TLocalDisplayMode;
}>`
  .video-container {
    position: absolute;
    overflow: hidden;
    ${({ displayMode, type }) => {
      return displayMode === 'full' && type === 'remote'
        ? fullStylesRemote
        : displayMode === 'full' && type === 'local'
        ? fullStyles
        : displayMode === 'window' && type === 'remote'
        ? windowStylesRemote
        : windowStyles;
    }}
  }

  video {
    min-width: auto;
    min-height: 100%;
    width: auto;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .switch-icon {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 50px;
    right: 50px;
    z-index: 99999;
    cursor: pointer;
  }

  .overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 180px;
    z-index: 99997;
    background: linear-gradient(
      180deg,
      rgba(000, 000, 000, 0) 0%,
      rgba(000, 000, 000, 0.5) 51.04%,
      #000 100%
    );
  }
`;
